const PROJECT_THUMBNAIL_FILENAMES = [
    "ProjectThumbnail01.jpg",
    "ProjectThumbnail02.jpg",
    "ProjectThumbnail03.jpg",
    "ProjectThumbnail04.png",
    "ProjectThumbnail05.jpg",
    "ProjectThumbnail06.jpg",
];

export const PROJECT_THUMBNAIL_PATHS = PROJECT_THUMBNAIL_FILENAMES.map(
    (fileName) => `/img/thumbnails/${fileName}`
);

let projectThumbnailPreloadPromise = null;

function normalizeProjectId(projectId) {
    if (typeof projectId === "string" || typeof projectId === "number") {
        return String(projectId);
    }
    return "";
}

function hashIdentifier(value) {
    let hash = 0;
    for (let index = 0; index < value.length; index += 1) {
        hash = ((hash << 5) - hash) + value.charCodeAt(index);
        hash |= 0;
    }
    return Math.abs(hash);
}

function canPreloadProjectThumbnails() {
    return typeof window !== "undefined" && typeof window.Image !== "undefined";
}

function preloadThumbnail(path) {
    return new Promise((resolve) => {
        const image = new window.Image();
        const encodedPath = encodeURI(path);

        image.onload = () => resolve(encodedPath);
        image.onerror = () => resolve(encodedPath);
        image.decoding = "async";
        image.src = encodedPath;
    });
}

export function preloadProjectThumbnails() {
    if (!PROJECT_THUMBNAIL_PATHS.length || !canPreloadProjectThumbnails()) {
        return Promise.resolve([]);
    }

    if (!projectThumbnailPreloadPromise) {
        projectThumbnailPreloadPromise = Promise.all(
            PROJECT_THUMBNAIL_PATHS.map((path) => preloadThumbnail(path))
        );
    }

    return projectThumbnailPreloadPromise;
}

export function getProjectThumbnailPath(projectId) {
    if (!PROJECT_THUMBNAIL_PATHS.length) {
        return null;
    }

    const normalizedProjectId = normalizeProjectId(projectId);
    if (!normalizedProjectId.length) {
        return encodeURI(PROJECT_THUMBNAIL_PATHS[0]);
    }

    const thumbnailIndex = hashIdentifier(normalizedProjectId) % PROJECT_THUMBNAIL_PATHS.length;
    return encodeURI(PROJECT_THUMBNAIL_PATHS[thumbnailIndex]);
}
